(function () {
  'use strict';

  const formSelector = [
    '.omnisend-form-6ac09fc2545781226629b88e-container',
    '.omnisend-form-6ac0a824545781226629b891-container',
  ].join(',');
  const popupCloseButtonSelector = [
    '#omnisend-form-6ac09fc2545781226629b88e-close-btn',
    '#omnisend-form-6ac0a824545781226629b891-close-btn',
  ].join(',');
  const popupStepSelector = [
    '.omnisend-form-6ac09fc2545781226629b88e-step-0-container',
    '.omnisend-form-6ac09fc2545781226629b88e-step-1-container',
    '.omnisend-form-6ac0a824545781226629b891-step-0-container',
    '.omnisend-form-6ac0a824545781226629b891-step-1-container',
  ].join(',');
  const teaserSelector = [
    '.omnisend-form-6ac09fc2545781226629b88e-rectangle-teaser',
    '.omnisend-form-6ac0a824545781226629b891-rectangle-teaser',
  ].join(',');
  const mobileFormSelector = '.omnisend-form-6ac09fc2545781226629b88e-container';
  const teaserCloseButtonSelector = [
    '#omnisend-form-6ac09fc2545781226629b88e-teaser-close-btn',
    '#omnisend-form-6ac0a824545781226629b891-teaser-close-btn',
  ].join(',');
  const teaserCloseIconSelector = [
    '#omnisend-form-6ac09fc2545781226629b88e-teaser-close-icon',
    '#omnisend-form-6ac0a824545781226629b891-teaser-close-icon',
  ].join(',');
  const teaserStateKey = 'uplief-offer-teaser-state-v1';
  const inactivityWindow = 30 * 60 * 1000;
  const forForms = (selector) => formSelector.split(',').map((form) => `${form} ${selector}`).join(',');
  const mobileStyleId = 'uplief-omnisend-mobile-form-styles';
  const root = document.documentElement;
  const body = document.body;
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  let saved = null;
  let checkQueued = false;
  let activityWriteAt = 0;

  function readTeaserState() {
    try {
      const state = JSON.parse(window.localStorage.getItem(teaserStateKey) || '{}');
      return {
        hasSeenPopup: state.hasSeenPopup === true,
        dismissedAt: Number(state.dismissedAt) || 0,
        lastActivityAt: Number(state.lastActivityAt) || 0,
      };
    } catch (error) {
      return { hasSeenPopup: false, dismissedAt: 0, lastActivityAt: 0 };
    }
  }

  let teaserState = readTeaserState();

  function saveTeaserState() {
    try {
      window.localStorage.setItem(teaserStateKey, JSON.stringify(teaserState));
    } catch (error) {
      return;
    }
  }

  function elementIsVisible(element) {
    if (!element || !element.getClientRects().length) return false;
    const style = window.getComputedStyle(element);
    return style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0';
  }

  function visiblePopup() {
    const closeButton = Array.from(document.querySelectorAll(popupCloseButtonSelector)).find(elementIsVisible);
    if (closeButton) return closeButton.closest(formSelector);
    const step = Array.from(document.querySelectorAll(popupStepSelector)).find(elementIsVisible);
    if (step) return step.closest(formSelector);
    return null;
  }

  function updateTeaserVisibility() {
    const popupOpen = Boolean(visiblePopup());
    const teasers = Array.from(document.querySelectorAll(teaserSelector));
    const returningWithTeaser = teasers.some(elementIsVisible);
    if ((popupOpen || returningWithTeaser) && !teaserState.hasSeenPopup) {
      teaserState.hasSeenPopup = true;
      saveTeaserState();
    }
    const dismissedForSession = teaserState.dismissedAt > 0 &&
      Date.now() - teaserState.lastActivityAt < inactivityWindow;
    teasers.forEach((teaser) => {
      if (!teaserState.hasSeenPopup || popupOpen || dismissedForSession) {
        teaser.style.setProperty('display', 'none', 'important');
      } else {
        teaser.style.removeProperty('display');
      }
    });
  }

  function recordActivity() {
    const now = Date.now();
    const wasDismissed = teaserState.dismissedAt > 0;
    if (teaserState.dismissedAt > 0 && now - teaserState.lastActivityAt >= inactivityWindow) {
      teaserState.dismissedAt = 0;
    }
    teaserState.lastActivityAt = now;
    if (now - activityWriteAt >= 15000 || (wasDismissed && teaserState.dismissedAt === 0)) {
      activityWriteAt = now;
      saveTeaserState();
    }
    updateTeaserVisibility();
  }

  if (teaserState.lastActivityAt && Date.now() - teaserState.lastActivityAt >= inactivityWindow) {
    teaserState.dismissedAt = 0;
  }
  teaserState.lastActivityAt = Date.now();
  saveTeaserState();

  function installMobileStyles() {
    if (document.getElementById(mobileStyleId)) return;
    const style = document.createElement('style');
    style.id = mobileStyleId;
    style.textContent = `
      ${teaserCloseButtonSelector} {
        box-sizing: border-box !important;
        display: inline-flex !important;
        align-items: center !important;
        justify-content: center !important;
        flex: 0 0 24px !important;
        width: 24px !important;
        height: 24px !important;
        padding: 0 !important;
        border: 1px solid #1F1D24 !important;
        border-radius: 50% !important;
        background-color: #FFF6E8 !important;
      }
      ${teaserCloseIconSelector} {
        flex: 0 0 10px !important;
        width: 10px !important;
        height: 10px !important;
      }
      ${forForms('.uplief-consent-wrapper')} {
        display: flex !important;
        width: 100% !important;
        max-width: 100% !important;
        justify-content: flex-start !important;
      }
      ${forForms('.uplief-consent-field')} {
        display: flex !important;
        flex: 1 1 100% !important;
        width: 100% !important;
        max-width: 100% !important;
      }
      ${forForms('.uplief-consent-label')} {
        align-items: flex-start !important;
        gap: 9px !important;
        padding: 0 !important;
        font-size: 13px !important;
        line-height: 1.42 !important;
      }
      ${forForms('.uplief-consent-label *')} {
        font-size: 13px !important;
        line-height: 1.42 !important;
        word-break: normal !important;
      }
      ${forForms('.uplief-consent-label input[type="checkbox"]')} {
        flex: 0 0 18px !important;
        width: 18px !important;
        height: 18px !important;
        margin: 1px 0 0 !important;
      }
      ${forForms('[class*="-step-1-container"] [class*="-text-"]')},
      ${forForms('[class*="-step-1-container"] [class*="-text-"] p')} {
        text-align: center !important;
      }
      ${forForms('.uplief-consent-field [class$="-description-container"]')} {
        display: inline-flex !important;
        align-items: center !important;
        justify-content: flex-start !important;
        gap: 4px !important;
        width: max-content !important;
        max-width: 100% !important;
      }
      ${forForms('.uplief-consent-field [class$="-description-link"]')} {
        display: inline-flex !important;
        align-items: center !important;
        margin-top: 0 !important;
      }
      @media (max-width: 767px) {
        ${mobileFormSelector} { z-index: 2147483000 !important; }
        ${mobileFormSelector} .uplief-consent-wrapper {
          display: flex !important;
          width: 100% !important;
          max-width: 100% !important;
          justify-content: flex-start !important;
        }
        ${mobileFormSelector} .uplief-consent-field {
          display: flex !important;
          flex: 1 1 100% !important;
          width: 100% !important;
          max-width: 100% !important;
        }
        ${mobileFormSelector} .uplief-consent-label {
          align-items: flex-start !important;
          gap: 9px !important;
          padding: 0 !important;
          font-size: 12px !important;
          line-height: 1.42 !important;
        }
        ${mobileFormSelector} .uplief-consent-label * {
          font-size: 12px !important;
          line-height: 1.42 !important;
          word-break: normal !important;
        }
        ${mobileFormSelector} .uplief-consent-label input[type="checkbox"] {
          flex: 0 0 18px !important;
          width: 18px !important;
          height: 18px !important;
          margin: 1px 0 0 !important;
        }
        ${mobileFormSelector} .uplief-consent-field [class$="-description"] {
          font-size: 11px !important;
          line-height: 1.35 !important;
        }
        ${mobileFormSelector} [class$="-content-inner"] {
          max-height: calc(100vh - 24px) !important;
          overflow-y: auto !important;
          -webkit-overflow-scrolling: touch !important;
          overscroll-behavior: contain !important;
        }
        @supports (height: 100dvh) {
          ${mobileFormSelector} [class$="-content-inner"] {
            max-height: calc(100dvh - 24px) !important;
          }
        }
      }
    `;
    (document.head || root).appendChild(style);
  }

  function styleConsent() {
    const forms = document.querySelectorAll(formSelector);
    if (!forms.length) return;
    installMobileStyles();
    forms.forEach((form) => {
      form.querySelectorAll('label[class*="-legal"]').forEach((label) => {
        const field = label.parentElement;
        if (!field || !field.className || !String(field.className).includes('-field-container-')) return;
        field.classList.add('uplief-consent-field');
        if (field.parentElement) field.parentElement.classList.add('uplief-consent-wrapper');
        label.classList.add('uplief-consent-label');
      });
    });
  }

  function visibleDialog() {
    return visiblePopup();
  }

  function lock(dialog) {
    if (saved) return;
    saved = {
      scrollX: window.scrollX,
      scrollY: window.scrollY,
      rootOverflow: root.style.overflow,
      rootOverscroll: root.style.overscrollBehavior,
      bodyOverflow: body.style.overflow,
      bodyPosition: body.style.position,
      bodyTop: body.style.top,
      bodyLeft: body.style.left,
      bodyRight: body.style.right,
      bodyWidth: body.style.width,
      dialogOverscroll: dialog.style.overscrollBehavior,
      dialog,
    };
    root.style.overflow = 'hidden';
    root.style.overscrollBehavior = 'none';
    body.style.overflow = 'hidden';
    dialog.style.overscrollBehavior = 'contain';
    if (isIOS) {
      body.style.position = 'fixed';
      body.style.top = `-${saved.scrollY}px`;
      body.style.left = `-${saved.scrollX}px`;
      body.style.right = '0';
      body.style.width = '100%';
    }
  }

  function unlock() {
    if (!saved) return;
    const previous = saved;
    saved = null;
    root.style.overflow = previous.rootOverflow;
    root.style.overscrollBehavior = previous.rootOverscroll;
    body.style.overflow = previous.bodyOverflow;
    if (isIOS) {
      body.style.position = previous.bodyPosition;
      body.style.top = previous.bodyTop;
      body.style.left = previous.bodyLeft;
      body.style.right = previous.bodyRight;
      body.style.width = previous.bodyWidth;
      window.scrollTo(previous.scrollX, previous.scrollY);
    }
    if (previous.dialog.isConnected) {
      previous.dialog.style.overscrollBehavior = previous.dialogOverscroll;
    }
  }

  function check() {
    checkQueued = false;
    styleConsent();
    updateTeaserVisibility();
    const dialog = visibleDialog();
    if (dialog) lock(dialog);
    else unlock();
  }

  function queueCheck() {
    if (checkQueued) return;
    checkQueued = true;
    window.requestAnimationFrame(check);
  }

  new MutationObserver(queueCheck).observe(body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'style', 'hidden', 'aria-hidden'],
  });
  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    const closeButton = target && target.closest(teaserCloseButtonSelector);
    if (!closeButton) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    teaserState.dismissedAt = Date.now();
    teaserState.lastActivityAt = teaserState.dismissedAt;
    saveTeaserState();
    updateTeaserVisibility();
  }, true);
  ['pointerdown', 'touchstart', 'keydown', 'scroll'].forEach((eventName) => {
    window.addEventListener(eventName, recordActivity, { passive: true });
  });
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') recordActivity();
  });
  window.addEventListener('storage', (event) => {
    if (event.key !== teaserStateKey) return;
    teaserState = readTeaserState();
    if (teaserState.lastActivityAt && Date.now() - teaserState.lastActivityAt >= inactivityWindow) {
      teaserState.dismissedAt = 0;
      saveTeaserState();
    }
    updateTeaserVisibility();
  });
  window.addEventListener('pagehide', unlock);
  window.addEventListener('resize', queueCheck);
  queueCheck();
})();
